export default {"src":"/_next/static/media/pc_consultunt_img_01.9ac08241.svg","height":140,"width":480};